import Category from "../components/Category";
import BreadcrumbShop from "../components/BreadcrumbShop";

const Appliances = () => {
  return (
    <div>
      <BreadcrumbShop curPage={"Appliances"} />
      <Category talk={"Appliances"} />
    </div>
  );
};

export default Appliances;
